// Module
var code = "<media-preview media=\"$ctrl.media\"></media-preview>";
// Exports
module.exports = code;